export enum SelectType {
  SINGLE_SELECT,
  MULTI_SELECT,
}

export interface AutocompleteOption {
  id: any;
  name: string;
  description?: string;
  isDisabled?: boolean;
  isLabel?: boolean;
  // Allows us to use a custom component for the option
  component?: React.JSX.Element;
}

export enum DIRECTION {
  UP,
  DOWN,
}
